import { createContext } from 'react';
// Inert by default, so a Menu that opts into nothing behaves as before.
export const MenuContext = createContext({
    revealItem: () => { },
});
